export default __webpack_public_path__ + "static/media/04.11.24 Minutes of the Regular Meeting.56680178.pdf";